<ng-template #portalContent>
  <ng-content></ng-content>
</ng-template>
